import { Icon, Menu, Persona } from '@ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { setTheme, useThemePreference, type ThemePreference } from '../../../lib/theme';
import { useSession } from '../session';
import { useSignOut } from './SignOut';
import styles from './UserMenu.module.css';

const THEMES: ThemePreference[] = ['light', 'dark', 'system'];

/** Signed-in user in the sidebar footer; opens a menu with appearance, profile and sign-out. */
export function UserMenu({ onNavigate }: { onNavigate?: () => void }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { me } = useSession();
  const signOut = useSignOut();
  const theme = useThemePreference();
  const go = (path: string) => {
    navigate(path);
    onNavigate?.();
  };
  return (
    <>
      <Menu
        placement="top"
        block
        trigger={(p) => (
          <button
            type="button"
            {...p}
            aria-label={t('userMenu.menu', { name: me.name })}
            className={styles.trigger}
          >
            <Persona name={me.name} secondary={me.email} size="sm" />
            <Icon name="chevrons-up-down" size="sm" className={styles.chevron} />
          </button>
        )}
        items={[
          {
            key: 'theme',
            label: t('theme.label'),
            value: theme,
            onChange: (value) => setTheme(value as ThemePreference),
            options: THEMES.map((value) => ({ value, label: t(`theme.${value}`) })),
          },
          {
            key: 'profile',
            separated: true,
            label: t('userMenu.profile'),
            onSelect: () => go('/einstellungen/profil'),
          },
          {
            key: 'sessions',
            label: t('userMenu.sessions'),
            onSelect: () => go('/einstellungen/sitzungen'),
          },
          {
            key: 'logout',
            label: t('userMenu.logout'),
            separated: true,
            disabled: signOut.pending,
            onSelect: signOut.start,
          },
        ]}
      />
      {signOut.dialog}
    </>
  );
}
